import { useMemo } from 'react';

import { EBroadcastTypes, Session, SessionTypesEnum } from '@/types/session.types';
import { TReactSelectOption } from '@ui/select/react-select/custom-react-select.types';

type Params = {
  session: Session | null;
  firesideHostOptions: TReactSelectOption<string, string, string>[];
};

const useKeepVideoSettingsSlidedownOpen = ({ session, firesideHostOptions }: Params) => {
  return useMemo(() => {
    if (!session) return;
    const shouldKeepOpenForFS = session.session_type === SessionTypesEnum.fireside && !firesideHostOptions.length;
    const shouldKeepOpenForTime = Object.values(session.requires_time_change || {}).some(Boolean);
    const typeHasContent =
      session.broadcast_type &&
      [EBroadcastTypes.rtmps, EBroadcastTypes.embed, EBroadcastTypes.fireside].includes(session.broadcast_type);
    const shouldKeepOpen = !!(typeHasContent && (shouldKeepOpenForFS || shouldKeepOpenForTime));

    return shouldKeepOpen;
  }, [session, firesideHostOptions]);
};

export default useKeepVideoSettingsSlidedownOpen;
